import { ECasinoGameViewOrder } from 'interfaces/casino-data';

export const encodeGameIdWithPrefix = (
  order: ECasinoGameViewOrder,
  id: string
) => {
  return `${order}-${id}`;
};

export const decodeGameIdWithPrefix = (id: string) => {
  const [order, gameId] = id.split('-');

  return {
    order: parseInt(order),
    gameId
  };
};
